module.exports = __webpack_public_path__ + "static/media/HCMM233.63274bb3.jpg";